module.exports = __webpack_public_path__ + "img/symbol_2.f30e7b1c.png";